import { RebateRule } from '@erp/shared-types';
import { RuleWithVersionState } from './types';

/**
 * Wrap an extracted rule with version state metadata
 *
 * Extracted rules default to includeInNewVersion: true
 */
export function wrapExtractedRule(rule: RebateRule): RuleWithVersionState {
  return {
    rule,
    includeInNewVersion: true,
    source: 'extracted',
    originalRule: structuredClone(rule),
    hasBeenEdited: false,
  };
}

/**
 * Wrap a previous version rule with version state metadata
 *
 * Previous rules default to includeInNewVersion: false (user must explicitly restore)
 */
export function wrapPreviousRule(rule: RebateRule): RuleWithVersionState {
  return {
    rule,
    includeInNewVersion: false,
    source: 'previous',
    originalRule: structuredClone(rule),
    hasBeenEdited: false,
  };
}

/**
 * Reset a rule to its original state
 *
 * Restores the rule from the originalRule backup and marks as not edited
 */
export function resetRuleToOriginal(
  wrapped: RuleWithVersionState,
): RuleWithVersionState {
  return {
    ...wrapped,
    rule: structuredClone(wrapped.originalRule),
    hasBeenEdited: false,
  };
}

/**
 * Update a rule and mark it as edited
 */
export function updateRule(
  wrapped: RuleWithVersionState,
  updatedRule: RebateRule,
): RuleWithVersionState {
  return {
    ...wrapped,
    rule: updatedRule,
    hasBeenEdited: true,
  };
}

/**
 * Toggle whether a rule should be included in the new version
 */
export function toggleIncludeInNewVersion(
  wrapped: RuleWithVersionState,
): RuleWithVersionState {
  return {
    ...wrapped,
    includeInNewVersion: !wrapped.includeInNewVersion,
  };
}
